import React from 'react';
import { Navbar, Container, Form, FormControl, Dropdown } from 'react-bootstrap';
import { FaUserCircle } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  return (
    <Navbar
      expand="lg"
      className="fixed-top"
      style={{
        backgroundColor: '#819A91',
        padding: '10px 20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 1050,
      }}
    >
      <Container fluid className="d-flex justify-content-between align-items-center">
        {/* Left - Brand */}
        <Navbar.Brand
          href="/"
          style={{
            color: '#EEEFE0',
            fontWeight: 'bold',
            fontSize: '24px',
            letterSpacing: '1px',
          }}
        >
          🛍️ Zayra Mart
        </Navbar.Brand>

        {/* Center - Search Bar */}
        <Form className="d-flex mx-4 flex-grow-1 justify-content-center" style={{ maxWidth: '500px' }}>
          <FormControl
            type="search"
            placeholder="Search..."
            className="me-2"
            aria-label="Search"
            style={{
              borderRadius: '20px',
              paddingLeft: '15px',
              border: 'none',
              outline: 'none',
              height: '36px',
              width: '100%',
            }}
          />
        </Form>

        {/* Right - Profile Dropdown */}
        <Dropdown align="end">
          <Dropdown.Toggle
            variant="light"
            style={{
              backgroundColor: '#EEEFE0',
              color: '#A7C1A8',
              fontWeight: 'bold',
              border: 'none',
              display: 'flex',
              alignItems: 'center',
              borderRadius: '20px',
              padding: '6px 12px',
            }}
          >
            <FaUserCircle className="me-2" size={20} />
            Profile
          </Dropdown.Toggle>

          <Dropdown.Menu style={{ minWidth: '150px' }}>
            <Dropdown.Item href="/profile">👤 My Profile</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item  onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.setItem("isAuthenticated", "false");
                  window.location.href = "/login";
                }}>🚪 Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Container>
    </Navbar>
  );
};

export default Header;
